// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridContainer, GridItem } from "@insite/mobius/index";
import Link from "@insite/mobius/Link";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import React, { useContext } from "react";

type Props = WidgetProps;

export interface EmailTesterStyles {
    container?: GridContainerProps;
}

export const emailTesterStyles: EmailTesterStyles = {};

const styles = emailTesterStyles;

interface EmailTesterResponeModel {
    message: string;
}

const EmailTester: React.FC<Props> = ({ fields: { isLocal, emailsDirectory } }) => {
    const toasterContext = useContext(ToasterContext);

    const sendEmail = (email: string) => {
        get<EmailTesterResponeModel>(
            `/api/v1/EmailTester/PublishSendEamil?readFromLocalDirectory=${isLocal}${
                isLocal ? `&directory=${emailsDirectory}` : ""
            }&templateName=${email}&sendEmail=true`,
        ).then(
            () => {
                toasterContext.addToast({
                    body: `${email} ${translate("Published and Sent")}`,
                    messageType: "success",
                });
            },
            () => {
                toasterContext.addToast({
                    body: `${email} ${translate("Published and Send faild")}`,
                    messageType: "danger",
                });
            },
        );
    };

    return (
        <GridContainer {...styles.container}>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("AbandonedCart")}>Abandoned Cart</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("Admin_AccountActivation")}>Admin Account Activation</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("Admin_ResetPassword")}>Admin Reset Password</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ContactUsTemplate")}>Contact Us Template</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ForgotPassword")}>Forgot Password</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("InviteToList")}>Invite To List</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ListEmailReminder")}>List Email Reminder</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("OrderApproval")}>Order Approval</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("OrderConfirmation")}>Order Confirmation</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("PunchOut_FailedOrderRequest")}>PunchOut Failed Order Request</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("RequestRMA")}>Request RMA</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("RfqQuote")}>Rfq Quote</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("SendAListCopy")}>Send A List Copy</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ShareInvoice")}>Share Invoice</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ShareListWithBillTo")}>Share List With BillTo</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ShareOrder")}>Share Order</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ShipmentConfirmation")}>Shipment Confirmation</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StatusReport")}>Status Report</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("TellAFriend")}>Tell A Friend</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("Website_AccountActivation")}>Website Account Activation</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("Website_ResetPassword")}>Website Reset Password</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("Website_UserNameChanged")}>Website User Name Changed</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("WishListLabelsPDF")}>Wish List Labels PDF</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("WishListLabelsPDFError")}>Wish List Labels PDF Error</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("VmiBinLabelsPDF")}>Vmi Bin Labels PDF</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("VmiBinLabelsPDFError")}>Vmi Bin Labels PDF Error</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StrAcceptBidEmailTemplate")}>Accept Bid Email</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StrAlignAccountEmailTemplate")}>Align Account Email</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StrContactFailureEmailTemplate")}>Contact Failure Email</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StrDeclineBidEmailTemplate")}>Decline Bid Email</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StrNotifyApproveOrderEmailTemplate")}>Notify Approve Order Email</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StrNotifyDeclineOrderEmailTemplate")}>Notify Decline Order Email</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StrNotifySubmitToOrderApprovalEmailTemplate")}>Notify Submit to Order Approval Email</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StrOrderSubmitFailureEmailTemplate")}>Order Submit Failure Email</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StrPageFeedbackEmailTemplate")}>Page Feedback Email</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StrPipeAndWireSheetEmailTemplate")}>Pipe and Wire Sheet Email</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StrPipeAndWireSheetSubscribeEmailTemplate")}>Pipe and Wire Sheet Subscribe Email</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StrRequestOnlineAccountTemplate")}>Request Online Account Email</Link>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: EmailTester,
    definition: {
        displayName: "Email Tester",
        group: "Xngage Custom" as any,
        fieldDefinitions: [
            {
                name: "isLocal",
                displayName: "Is Local Enviroment",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: "emailsDirectory",
                displayName: "Emails Directory",
                editorTemplate: "TextField",
                fieldType: "General",
                defaultValue: "",
                isRequired: true,
                isVisible: item => item.fields.isLocal,
            },
        ],
    },
};

export default widgetModule;
